module.exports = __webpack_public_path__ + "img/34.80a23d7f.svg";